import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';

const SLayout = styled.div`
    position: relative;
    height: 35px;
    /* background: #dcdcdc; */
`;

const SAbsoluteLayout = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    /* overflow-x: scroll; */
    flex-wrap: wrap;
`;

const SItemLayout = styled.div`
    display: flex;
    overflow-x: auto;
`;

const SItem = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 15px;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    margin-right: 3px;
    border: 1px solid #dcdcdc;
    border-top: ${(props) => (props.selected ? '1px solid #fff' : '1px solid #dcdcdc')};
    color: ${(props) => (props.disabled ? 'rgba(0,0,0,0.7)' : props.selected ? '#4190BE' : '#000')};
    background: ${(props) => (props.disabled ? '#dcdcdc' : '#fff')};
    font-size: 12px;
    font-weight: bold;
    transition: all 0.3s;
    flex-shrink: 0;
    position: relative;
    user-select: none;
    border-radius: ${(props) => (props.selected ? '0px' : '0px')};
    border-bottom-right-radius: 3px;
    border-bottom-left-radius: 3px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;

    overflow: hidden;

    &:hover {
        /* background: ${(props) => (props.selected ? '#808080' : '#a9a9a9')}; */
        color: ${(props) => (props.disabled ? 'inherit' : props.selected ? '#4190BE' : '#4190BE')};
    }
`;

const SSelectIndicator = styled.div`
    height: 5px;
    background: #4190be;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
`;

const SUpperLine = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 2px;
    background: #dcdcdc;
`;

const SSelectTopLine = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: #fff;
`;

const CustomTab = ({
    data = [
        { key: 'test', display: 'Test' },
        { key: 'test2', display: 'Test2', isHidden: true, disabled: false },
    ],
    value = 'test',
    onClick = () => null,
}) => {
    const [selected, setSelected] = useState('');

    useEffect(() => {
        const res = data.find((item) => {
            return item.key === value;
        });

        if (res) {
            setSelected(res.key);
        }
    }, [data, value]);

    return (
        <SLayout>
            <SUpperLine />
            <SAbsoluteLayout>
                <SItemLayout>
                    {data.map((item) => {
                        if (item.isHidden) {
                            return null;
                        }

                        return (
                            <SItem
                                selected={selected === item.key}
                                onClick={() => {
                                    if (!item.disabled) {
                                        onClick(item);
                                    }
                                }}
                                key={item.key}
                                disabled={item.disabled}
                            >
                                {item.type === 'hospital' ? `Site (${item.display})` : item.display}
                                {selected === item.key && <SSelectIndicator />}
                                {selected === item.key && <SSelectTopLine />}
                            </SItem>
                        );
                    })}
                </SItemLayout>
            </SAbsoluteLayout>
        </SLayout>
    );
};

export default CustomTab;
